// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2024-04-30T08:48:24+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  180175
//    Project:        500
//    Environment:    3504 - master
//    MD5:            33a8b5f26297d82a1da13558d2655b88
//    Signature:      eyJpdiI6IkZjS0VuR1pDbVRPd2M1Z0NReXY2MFE9PSIsInZhbHVlIjoieVBwQlIwNDgxZHhENVkxTVhoK3FXejBtdGJJeEJNNjIrb3RXK29uaTRkYmpSaFNaYXNaYzZyRHFNRHdMRk5IMjV4SkVSQlBpNUtVcEZKbkZMR3VkOEduWW94VXczWlRtQUVGR0ZTNmMrU29rdFZFWVRjWXdkaVJ6cnV3M2Ziemx3eDVtRWdjTXRPZnBCSW5NSXJBeklCZ2dUUTJKV1d2UDJIQmk3TXc4UlQrNDg4U2dVbFVzUjJTcWd6RFFIUk9UeWExWUU5bngrQzhRaDJhd1VSR3VPZkNEMnZBaXRXVXdcL1dcL2JYa2hPKzByZ2hZaUg3am9ySlpZM2VWMWlRcjkxelQ5R3hZMDV2MG1IdzRXUlM0QW0xb1czSnhqWWxtR3FyanVOVDdXOXU3STZKOXhVWWh2T1VRVGVidnhxRHBSU1lFTmlFZEM3UVJtd1lcL3JBSnNiaDRWcGdqK25sUUhIQ1g4Umk1TnFYZnFSTEhySEUxU0ZkVjhENVwvV2RUNVIwWG1cL0EycEhhejNETlwvQUNXNFN0V3BmZz09IiwibWFjIjoiNGZmNWE3NTdiNGViMmMyMThmYzc3ZDgyYjMzYmI5ZTlhY2EwMzExNDVmZDQwMDE3OWJjN2QwNTc3ZTcyNjRkZCJ9
// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2023-02-01T12:10:44+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  166479
//    Project:        500
//    Environment:    3504 - master
//    MD5:            997d500e5efafff5b5f2ebd218530601
//    Signature:      eyJpdiI6IkNuTHoyRmgyOFBIclhHZUpvV3pFZ1E9PSIsInZhbHVlIjoiZ0luMnpLV01nZnZDcDhCaUlYaTRsSUNKWVFcL3BcL0xLVWNaTWFVaFwveUJXWVV6WFoxOFBxYzFTYlE2U2s4WDc2MEVGcHdFcFJHZkJhcUppM0ZDNStKNGszSTlFdTBLMnBLQlkzQXNwbkxNSkR5YmtNbUVjTWc3NUxueXdyVjFrSklYa0krTWxFUTVFdXVnZWdOWUxjZ3JVNEJpb21qMkVqNStHNDJUTWVDd240ZW4weVJpZnlwWXBINStvbmdJMStkUGtpOFRcL1lBR1R4UjMyVUtZbXBlZTFFOFdRejhKRWJzM2xMNjA5TW8xYVdkQTlpcUFRQjl5XC9QWDY3U1ByRVwvXC9vcm10dWlHdlhocFhvc0ZEY3Y2ZjUyU1JMMmlXZEcyXC9BOG9XOFlYM2IxalBmTUM3RXlaSkpHdk1YUDczejZoVkdsWnZrWjI5RWlxVW92cDFjZDhBaExzeXJZY2VBaEV1U3RNWlpheEl1YXZ2RVRcLzRqK3dOYkZrNVYybHdoMG5odE5JZ1hnWTBnV1IwTEg1NnVXZTNtUT09IiwibWFjIjoiN2ZiNzlmZWNjMTY4MDU1NzJmYzZjZjhkYjAwMTlkYmU4NjkxYWJkZmY4NTA5NzI5OGE4OWVmNmQxN2VmMGRmMSJ9
var boostPFS = new BoostPFS();
boostPFS.init(); 
if (typeof boostPFSConfig != 'undefined'
	&& typeof boostPFSConfig.general != 'undefined' 
	&& typeof boostPFSConfig.general.isInitFilter != 'undefined'
	&& typeof boostPFSThemeConfig != 'undefined'
	&& boostPFSConfig.general.isInitFilter === true) {
	boostPFS.initFilter(); 
} 
BoostPFS.jQ(window).on('load', function(){
	boostPFS.initSearchBox();
	/** boostPFS.initAnalytics() **/;
});